import { Injectable, Injector } from "@angular/core";
import { environment } from "@environments/environment";
import { Service } from "@services/service";

@Injectable()
export class DashboardService extends Service {
	constructor(injector: Injector) {
		super("Dashboard", injector);
	}

	// API
	dataHealth() {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/DataHealth`);
	}

	financial() {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/Financial`);
	}
	
	getForCurrentUser() {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/ForCurrentUser`);
	}

	productionForecast() {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/ProductionForecast`);
	}

	productionForecastCSV() {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/ProductionForecastCSV`, { responseType: "blob" as "json"});
	}

	staffAttendance() {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/StaffAttendance`);
	}
}